<template>
  <div class="addMessageType">
    <!--新增-->
    <el-dialog
      :title="$t('transportDeliveryOrder.sendMessage.customerTitle')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="866px"
    >
      <el-form
        label-width="auto"
        :model="formData"
        :rules="rules"
        ref="formData"
        :label-position="'right'"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item
              prop="salesLadingNo"
              :label="this.$t('transportDeliveryOrder.sendMessage.outboundBusinessPerson')"
            >
              <el-input v-model="formData.outboundBusinessPersonName" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="allotNo"
              :label="this.$t('transportDeliveryOrder.sendMessage.customerNo')"
            >
              <el-input v-model="formData.customerName" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="sendPhone"
              :label="this.$t('transportDeliveryOrder.sendMessage.contactCustomerPhone')"
            >
              <!-- <el-input v-model="formData.sendPhone" 
                            :placeholder='this.$t("transportDeliveryOrder.sendMessage.contactPhonePlaceholder")'>
                        </el-input> -->
              <el-select
                v-model="formData.sendPhone"
                filterable
                multiple
                :placeholder="this.$t('transportDeliveryOrder.sendMessage.contactPhonePlaceholder')"
                clearable
              >
                <el-option
                  v-for="item in sendPhoneOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              prop="sendMsg"
              :label="this.$t('transportDeliveryOrder.sendMessage.content')"
            >
              <el-input
                v-model="formData.sendMsg"
                :placeholder="this.$t('transportDeliveryOrder.sendMessage.contentPlaceholder')"
                type="textarea"
                :rows="3"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="load" @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
        <el-button :loading="load" type="primary" @click="sendMessage">{{
          $t('dialog.send')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/logisticsCenter/transportDeliveryOrder.js';
  import masterObj from '@/common/js/masterObj';
  // import SearchModal from '@/components/SearchModal';
  import formRules from '../rules/rules';
  import { mapState } from 'vuex';

  const last = '如【税号】等开票信息有变更，请及时告知我司业务员';
  export default {
    name: 'detailMessageTask',
    components: {
      // SearchModal,
    },
    data() {
      return {
        load: false,
        dialogAdd: false,
        formData: {
          customerName: '',
          sendMsg: '',
          sendPhone: [],
        },
        rules: formRules.sendMessage,
        warehouseName: '',
        partner: masterObj.customer,
        warehouse: masterObj.warehouse,
        person: masterObj.person,
        first: '',
        center: '',
        outboundNo: '',
        sendPhoneOptions: [], //电话号码
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    methods: {
      openDialog(flag, data) {
        if (this.$refs['formData']) {
          this.$refs['formData'].resetFields();
        }
        this.dialogAdd = flag;
        this.warehouseName = data.outboundStorageName;
        this.formData.customerName = data.customerName;
        this.formData.outboundBusinessPersonName = data.outboundBusinessPersonName;
        this.outboundNo = data.outboundNo;
        this.getDetail(data.outboundNo, data);
      },
      //获取电话
      async getsendPhone(partnerCode, departmentCode) {
        const selectStatus = await this.$axios.get(
          `${API.GET_PHONE}?partnerCode=${partnerCode}&departmentCode=${departmentCode}`
        );
        if (selectStatus.data.code == 0) {
          this.sendPhoneOptions = [];
          selectStatus.data.data.map((item) => {
            let obj = {
              value: item,
              label: item,
            };
            this.sendPhoneOptions.push(obj);
          });
        }
      },
      //获取详细信息
      getDetail(outboundNo, data) {
        this.$axios.get(API.DETAIL_TRANSPORTDELIVERYORDER_API + outboundNo).then((res) => {
          if (0 == res.data.code) {
            let formData = res.data.data;
            let transport =
              res.data.data.deliveryTransportList && res.data.data.deliveryTransportList.length > 0
                ? res.data.data.deliveryTransportList[0]
                : null;
            let product = res.data.data.outboundDetailList[0];
            let businessOrderQuantity =
              product.businessOrderQuantity || product.businessOrderPackage;
            let productInfo =
              product.productName + ' ' + businessOrderQuantity + product.productUnitName;
            this.first = '您的提货单【' + outboundNo + '】' + productInfo + '等。';
            let nameVoyageLicense = transport
              ? '提货车牌号：' + transport.nameVoyageLicense + '，'
              : '';
            let contactPhoneNo = transport ? transport.contactPhoneNo : '';
            this.center =
              nameVoyageLicense +
              '已传真至【' +
              this.warehouseName +
              '】仓库。如有提货问题，请联系物流专员：' +
              contactPhoneNo +
              '。';
            let customerName = this.formData.customerName ? this.formData.customerName : '';
            this.formData.sendMsg =
              '【' +
              customerName +
              '】，' +
              this.first +
              this.center +
              last +
              '【' +
              this.userInfo.userInfo.companyName +
              '】';
            this.formData.customerNo = formData.customerNo;
            this.getsendPhone(this.formData.customerNo, data.departmentCode);
          }
        });
      },
      //选择联系人
      setContactPerson(val, row) {
        if (row.length > 0) {
          this.formData.contactPerson = row[0].returnSalesmanName;
          this.formData.contactPersonName = row[0].returnSalesmanName;
          this.formData.sendMsg =
            '【' + this.formData.customerName + '】' + this.first + this.center + last;
        }
      },
      //选择客户
      setCustomer(val, row) {
        if (row.length > 0) {
          this.formData.customerNo = row[0].partnerCode;
          this.formData.customerName = row[0].partnerZhName;
          this.formData.sendMsg =
            '【' + this.formData.customerName + '】' + this.first + this.center + last;
        }
      },
      //发送短信
      sendMessage() {
        this.$refs.formData.validate((valid) => {
          if (valid) {
            this.load = true;
            let params = {
              outboundNo: this.outboundNo,
              sendPhone: this.formData.sendPhone.join(','),
              sendMsg: this.formData.sendMsg,
            };
            this.$axios.post(API.SENDMESSAGE_TRANSPORTDELIVERYORDER_API, params).then((res) => {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              this.load = false;
              if (0 == res.data.code) {
                this.dialogAdd = false;
              }
            });
          }
        });
      },
    },
  };
</script>
